/* Block - Merchant Listing.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 */
/* eslint-disable */
import styles from "./block-merchant-listing.scss";
import jQueryBridget from 'jquery-bridget';
import Isotope from 'isotope-layout';
import ImagesLoaded from 'imagesloaded';

jQuery(document).ready(function ($) {
    jQueryBridget('imagesLoaded', ImagesLoaded, $);
    jQueryBridget('isotope', Isotope, $);

    const initBlockMerchantListing = function () {
        let qsRegex;

        function debounce(fn, threshold = 100) {
            let timeout;
            return function debounced(...args) {
                clearTimeout(timeout);
                const _this = this;

                function delayed() {
                    fn.apply(_this, args);
                }
                timeout = setTimeout(delayed, threshold);
            };
        }

        let initialGridElementsLength;

        function getIsotopeOptions(itemSelector, layoutMode = 'fitRows') {
            return {
                itemSelector,
                layoutMode,
                hiddenStyle: {
                    opacity: 0
                },
                visibleStyle: {
                    opacity: 1
                },
                transitionDuration: 0,
                filter: function () {
                    return qsRegex ? $(this).text().match(qsRegex) : true;
                },
            };
        }

        function initializeIsotope($element, options) {
            $element.imagesLoaded(function () {
                $element.isotope(options);
            });
        }

        function applyIsotopeToGrid($grid, $subGrids, filterValue = '*') {
            $grid.isotope({
                filter: filterValue
            });

            $subGrids.each(function () {
                let $currentItem = $(this);
                let imagesLoaded = $currentItem.data('imagesLoaded');
                if (imagesLoaded.isComplete) {
                    $currentItem.isotope(getIsotopeOptions('.merchant', 'masonry'));
                }
            });

            $grid.isotope();
            $subGrids.each(function () {
                $(this).isotope();
            });
        }

        function applyIsotopeSearchToGrid($grid, $subGrids) {
            $grid.isotope({
                filter: function () {
                    return qsRegex ? $(this).text().match(qsRegex) : true;
                }
            });

            $subGrids.each(function () {
                let $currentItem = $(this);
                let imagesLoaded = $currentItem.data('imagesLoaded');
                if (imagesLoaded.isComplete) {
                    $currentItem.isotope(getIsotopeOptions('.merchant', 'masonry'));
                }
            });

            $grid.isotope();
            $subGrids.each(function () {
                $(this).isotope();
            });
        }

        function updateMerchantCategoriesLinks($grid, $merchantCategoriesLinks) {
            let getFilteredCategoryItems = $grid.data('isotope').filteredItems;

            if (getFilteredCategoryItems.length === initialGridElementsLength) {
                let $merchantCategoriesLinks = $('.merchant-categories-links');
                $merchantCategoriesLinks.find('.is-checked').removeClass('is-checked');
                $merchantCategoriesLinks.find(`[data-filter="*"]`).addClass('is-checked');
            } else if (getFilteredCategoryItems.length) {
                let filteredCategory = getFilteredCategoryItems[0].element.getAttribute('data-category');
                $merchantCategoriesLinks.find('.is-checked').removeClass('is-checked');
                $merchantCategoriesLinks.find(`[data-filter=".${filteredCategory}"]`).addClass('is-checked');
            }
        }

        const $grid = $('.card-grid');
        initializeIsotope($grid, getIsotopeOptions('.merchant-category'));

        const $subGrids = $('.card-sub-grid');
        $subGrids.each(function () {
            initializeIsotope($(this), getIsotopeOptions('.merchant', 'masonry'));
        });

        $grid.one('arrangeComplete', function (event, filteredItems) {
            initialGridElementsLength = filteredItems.length;
        });

        $grid.on('arrangeComplete', function (event, filteredItems) {
            if (filteredItems.length === initialGridElementsLength) {
                let $merchantCategoriesLinks = $('.merchant-categories-links');
                $merchantCategoriesLinks.find('.is-checked').removeClass('is-checked');
                $merchantCategoriesLinks.find(`[data-filter="*"]`).addClass('is-checked');
            }
        });

        const $quicksearch = $('#merchant-search').keyup(debounce(function () {
            qsRegex = new RegExp($quicksearch.val(), 'gi');
            applyIsotopeSearchToGrid($grid, $subGrids);
            updateMerchantCategoriesLinks($grid, $('.merchant-categories-links'));

            $('.merchant-category-digital').hide();
            $('html, body').scrollTop($('.card-grid').offset().top - 100);
        }, 200));

        $('.merchant-categories-links').on('click', 'button', function () {
            $('#no-merchants-found').hide();
            $('#merchant-search').val('');
            qsRegex = new RegExp($('#merchant-search').val(), 'gi');

            const filterValue = $(this).attr('data-filter');
            applyIsotopeToGrid($grid, $subGrids, filterValue);

            if (filterValue === ".merchant-category-digital") {
                $('.merchant-category-digital').show('fast', function () {
                    applyIsotopeToGrid($grid, $subGrids, filterValue);
                });
            } else {
                $('.merchant-category-digital').hide();
            }

            $('.merchant-categories-links').find('.is-checked').removeClass('is-checked');
            $(this).addClass('is-checked');

            $('html, body').scrollTop($('.card-grid').offset().top - 100);

            $grid.isotope();
        });

        // Create on scroll listener for .card-grid element


        // Autocomplete Functionality

        // let $merchantNames = $('.merchant-name');
        // let merchantNamesArray = [];

        // $merchantNames.each(function () {
        //     merchantNamesArray.push($(this).text());
        // });

        // merchantNamesArray = [...new Set(merchantNamesArray)];

        // // Sort merchant names array alphabetically
        // merchantNamesArray.sort(function (a, b) {
        //     return a.localeCompare(b);
        // });

        // $("#merchant-search").autocomplete({
        //     source: merchantNamesArray,
        //     close: function (event, ui) {
        //         qsRegex = new RegExp($('#merchant-search').val(), 'gi');
        //         applyIsotopeSearchToGrid($grid, $subGrids);

        //         updateMerchantCategoriesLinks($grid, $('.merchant-categories-links'));

        //         $('.merchant-category-digital').hide();
        //         $('html, body').animate({
        //             scrollTop: $('.card-grid').offset().top - 100
        //         }, 0);
        //     }
        // });

        function getQueryFilter() {
            const params = new URLSearchParams(window.location.search);
            const filter = params.get('filter');
            return filter ? decodeURIComponent(filter) : null;
        }

        $(window).on('load', function () {
            let queryFilter = getQueryFilter();
            if (queryFilter) {
                $('.merchant-categories-links').find('.is-checked').removeClass('is-checked');
                $('.merchant-categories-links').find(`[data-filter=".merchant-category-${queryFilter}"]`).addClass('is-checked');
                $grid.isotope({
                    filter: `.merchant-category-${queryFilter}`
                });
            }

            if (queryFilter === 'digital') {
                $('.merchant-category-digital').show();
            } else {
                $('.merchant-category-digital').hide();
            }

            $grid.isotope();
        });

        $(window).on('scroll', debounce(function () {
            const $cardGrid = $('.card-grid');
            const $merchantCategories = $('.merchant-category');

            const cardGridOffset = $cardGrid.offset().top;

            if (window.scrollY >= cardGridOffset) {
                let $merchantListingSidebar = $('.merchant-listing-sidebar');
                let sidebarTopPosition = $merchantListingSidebar.offset().top;
                let currentCategory;

                $merchantCategories.each(function () {
                    const categoryOffset = $(this).offset().top;
                    const categoryHeight = $(this).outerHeight(true);
                    if (sidebarTopPosition >= categoryOffset && sidebarTopPosition <= categoryOffset + categoryHeight) {
                        currentCategory = $(this).data('category');
                        $('.merchant-categories-links').find('.is-checked').removeClass('is-checked');
                        $('.merchant-categories-links').find(`[data-filter=".${currentCategory}"]`).addClass('is-checked');
                    }
                });
            }
        }, 200));
    };

    initBlockMerchantListing();
});
